<div class="dialog-header">
    <h2 mat-dialog-title>New Fund Valuation</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="fundValuationForm">
        <div>
            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Closing Date</mat-label>
                <input matInput
                       formControlName="closingDate"
                       [errorStateMatcher]="closingDateErrorMatcher"
                       [matDatepicker]="closingDatePicker">
                <mat-hint>dd/MM/yyyy</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="closingDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #closingDatePicker></mat-datepicker>
                @if (fundValuationForm.controls.closingDate.hasError('required')) {
                    <mat-error>
                        Closing date is required
                    </mat-error>
                }
                @if (fundValuationForm.controls.closingDate.hasError('dateBefore')) {
                    <mat-error>
                        Closing date cannot be before the report date
                        {{ fundValuationForm.controls.closingDate.getError('dateBefore').requiredDate | date }}.
                    </mat-error>
                }
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Description</mat-label>
                <input matInput formControlName="description">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Valuation Type</mat-label>
                <mat-select formControlName="valuationType">
                    @for (type of fundValuationTypes; track type) {
                        <mat-option [value]="type">
                            {{ type | codeFormat: codeTableFundValuationType | async }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Cashflow Pattern</mat-label>
                <input matInput
                       [formControl]="templateSearchControl"
                       [matAutocomplete]="templateAuto"
                       placeholder="Search templates...">
                @if (selectedTemplateId) {
                    <button mat-icon-button matSuffix (click)="clearTemplate()" type="button">
                        <mat-icon>close</mat-icon>
                    </button>
                }
                <mat-autocomplete #templateAuto="matAutocomplete"
                                  (optionSelected)="onTemplateSelected($event)">
                    @for (template of filteredTemplates$ | async; track template.id) {
                        <mat-option [value]="template">
                            {{ template.name.text }}{{ template.isDefault.value ? ' (Default)' : '' }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button
        mat-stroked-button
        color="primary"
        [mat-dialog-close]="true"
        [disabled]="fundValuationForm.invalid"
        (click)="createFundValuation()">
        Create
    </button>
</mat-dialog-actions>
